export default "__VITE_ASSET__DWDconjr__"